import { store } from '../../core/store.js';
import { compileCode } from '../../core/wasm.js';

export async function buildPreviewDocument(options = {}) {
  const html = options.html ?? store.get('html');
  const css = options.css ?? store.get('css');
  const js = options.js ?? store.get('js');
  const theme = options.theme ?? store.get('activeTheme');
  const activeRoute = options.activeRoute ?? store.get('activePreviewRoute') ?? '';
  const activePath = options.activePath ?? store.get('activePreviewPath') ?? 'index.html';

  return compileCode(html, css, js, theme, activeRoute, activePath, {
    restoreScroll: options.restoreScroll || null
  });
}
